
export enum LocalStorageEnum {
    authData,
    previousUrl
}


// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/app/enums/local.storage.enum.ts